import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import Swal from 'sweetalert2';
import { api } from '../services/api';

// Tela cheia de uma chave PIX especifica do cliente logado. Exibe QR code,
// chave copia-e-cola e botao de copiar. Fetch por id + CGC do JWT (backend
// garante que o cliente so ve chaves proprias).

function formatarMoeda(valor) {
  if (valor == null) return null;
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(parseFloat(valor));
}

function formatarData(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export default function MinhasChavesPixDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [chave, setChave] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get(`/pix/minhas/${encodeURIComponent(id)}`);
      setChave(data);
      setErro(null);
    } catch (e) {
      setErro(e?.response?.data?.error || 'Nao foi possivel carregar essa chave PIX.');
    } finally {
      setCarregando(false);
    }
  }, [id]);

  useEffect(() => { carregar(); }, [carregar]);

  const copiar = async () => {
    if (!chave?.brcode) return;
    try {
      await navigator.clipboard.writeText(chave.brcode);
      Swal.fire({
        icon: 'success',
        title: 'Chave copiada!',
        text: 'Cole no seu app do banco para concluir o pagamento.',
        confirmButtonColor: '#2e9846',
        timer: 2500,
        showConfirmButton: false,
      });
    } catch (_) {
      Swal.fire({
        icon: 'error',
        title: 'Nao foi possivel copiar',
        text: 'Selecione a chave manualmente e copie pelo navegador.',
        confirmButtonColor: '#2e9846',
      });
    }
  };

  const pendente = chave?.status === 'Pendente';
  const pago = chave?.status === 'Pagamento efetuado!';

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <button
          type="button"
          className="btn-ghost-cli"
          onClick={() => navigate('/minhas-chaves-pix')}
        >
          <i className="bi bi-arrow-left" style={{ marginRight: 6 }} />
          Voltar para a lista
        </button>
      </div>

      {carregando ? (
        <div className="card-cli">
          <p style={{ color: 'var(--texto-suave)', margin: 0 }}>Carregando…</p>
        </div>
      ) : erro ? (
        <div className="card-cli" style={{ borderColor: '#f4baba', background: '#fde2e2' }}>
          <p style={{ color: '#9b2424', margin: 0 }}>{erro}</p>
        </div>
      ) : !chave ? null : (
        <div className="card-cli" style={{ maxWidth: 560, marginInline: 'auto' }}>
          <div
            className={'pix-status-cli ' + (pago ? 'pix-status-pago-cli' : pendente ? 'pix-status-pendente-cli' : 'pix-status-erro-cli')}
            style={{ marginBottom: 14 }}
          >
            <i className={'bi ' + (pago ? 'bi-check-circle-fill' : pendente ? 'bi-hourglass-split' : 'bi-x-circle-fill')} />
            <span>{chave.status}</span>
          </div>

          {chave.valor != null && (
            <div className="pix-valor-cli">
              <span className="pix-valor-label-cli">Valor</span>
              <strong>{formatarMoeda(chave.valor)}</strong>
            </div>
          )}

          {pendente && chave.brcode ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', margin: '12px 0' }}>
                <QRCodeSVG size={220} value={chave.brcode} includeMargin />
              </div>
              <p style={{ textAlign: 'center', color: 'var(--texto-suave)', margin: '4px 0 12px' }}>
                <i className="bi bi-qr-code-scan" /> Abra o app do seu banco e escaneie
              </p>
              <button type="button" className="pix-btn-copiar-cli" onClick={copiar}>
                <i className="bi bi-clipboard-check" /> Copiar chave PIX
              </button>
              <p className="pix-ou-cli">— ou copie a chave manualmente —</p>
              <button
                type="button"
                className="pix-chave-cli"
                onClick={copiar}
                title="Toque para copiar"
              >
                {chave.brcode}
              </button>
            </>
          ) : pago ? (
            <p style={{ textAlign: 'center', color: 'var(--texto-suave)', margin: '12px 0' }}>
              Este pagamento ja foi confirmado. Guarde este comprovante para consulta.
            </p>
          ) : null}

          <div className="pix-info-pedido-cli" style={{ marginTop: 14 }}>
            {chave.numped && (
              <div><span>Pedido</span><strong>{chave.numped}</strong></div>
            )}
            {chave.dataGeracao && (
              <div><span>Gerada em</span><strong>{formatarData(chave.dataGeracao)}</strong></div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
